import springCenfApi from '../../services/springCenfApi'

export const getVehicleTypes = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/vehicle_types', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getVehicleType = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/vehicle_types/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeVehicleType = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/vehicle_types', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateVehicleType = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/vehicle_types/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteVehicleType = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/vehicle_types/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)